import { createSlice } from "@reduxjs/toolkit";
import { fetchSaasBillingList } from "../Thunks/saasBillingThunk";
import { applySubResourceRejected } from "../helpers/asyncResource";

const initialState = {
  list: {
    data: [],
    loading: false,
    error: null,
  },
};

export const saasBillingSlice = createSlice({
  name: "saasBilling",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSaasBillingList.pending, (state) => {
        state.list.loading = true;
        state.list.error = null;
      })
      .addCase(fetchSaasBillingList.fulfilled, (state, action) => {
        state.list.loading = false;
        state.list.error = null;
        state.list.data = action.payload || [];
      })
      .addCase(fetchSaasBillingList.rejected, (state, action) => {
        applySubResourceRejected(state.list, action, "Failed to load SaaS module billing");
      });
  },
});

export const selectSaasBillingList = (state) => state.saasBilling.list.data;
export const selectSaasBillingLoading = (state) => state.saasBilling.list.loading;
export const selectSaasBillingError = (state) => state.saasBilling.list.error;

export default saasBillingSlice.reducer;
